import { ReactComponent as GithubIcon } from 'assets/icons/logos/github24.svg'
import cx from 'classnames'
import { FormatBar } from 'common/Prose/components/FormatBar/FormatBar'
import { nodes, StrongNode } from 'prose-core'
import { forwardRef, useRef } from 'react'
import { useReactNodeView } from '../ReactNodeView/ReactNodeViewContext'
import styles from './GithubEmbed.module.scss'
import { GithubIssue } from './GithubIssue'
import { GithubPull } from './GithubPull'

export const GithubEmbed = forwardRef<HTMLDivElement, {}>(() => {
  const context = useReactNodeView()
  const { node } = context
  const isSelected = context.isSelected ?? false
  const isInline = node?.attrs.mode === 'inline'
  const selfRef = useRef<HTMLDivElement>(null)

  return (
    <div
      className={cx(styles.githubEmbed, { [styles.isSelected]: isSelected, [styles.inline]: isInline })}
      ref={selfRef}
    >
      {isSelected && (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        <FormatBar icon={GithubIcon} title="GitHub Embed" mode={node!.attrs.mode} url={node!.attrs.link} />
      )}
      {(() => {
        switch (node?.attrs.type) {
          case 'issue':
            return <GithubIssue node={node as StrongNode<typeof nodes.github_embed>} />
          case 'pull':
            return <GithubPull node={node as StrongNode<typeof nodes.github_embed>} />
        }
      })()}
    </div>
  )
})
